namespace Areas.Budget.Edit {
    "use strict";


    var tabItems = Areas.createTabsWithSameAction("Budget", "Edit",
        ["Profile", "BudgetEntry", "UnLinked", "Linked", "AutoLinked", "Summary", "Detail", "Filter", "Reclass", "Memos"]);

    export function tabInitialized(params: any) {
        return Areas.tabWithIdInitialized(tabItems)(params);
    }

    export function returnToListFromTab() {
        var linkInfo = "/Budget/List/Active";
        location.href = linkInfo;

    }

    export function goToProject() {
        const linkedGrid = $("#BudgetListGrid").dxDataGrid("instance");
        let accountId = linkedGrid.option("accountId");

        let linkInfo = "/Account/Profile/View/" + accountId;
        window.open(linkInfo);
    }
}
